import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';
import { ConstantsModule } from '../constants/constants.module';
import { DialogPage } from '../root_classes/dialog-page';

@Component({
  selector: 'app-user-generate-new-password',
  templateUrl: './user-generate-new-password.component.html',
  styleUrls: ['./user-generate-new-password.component.scss']
})
export class UserGenerateNewPasswordComponent extends DialogPage implements OnInit {

  // Extra data.
	public userId: string = "";
	public userName: string = "";
	public buttonText: string;
	public enableAction: boolean;

  constructor(constantsModule:ConstantsModule, cookieService:CookieService, httpClient:HttpClient, router:Router, modalService:NgbModal, modalInstance:NgbActiveModal) {
		super(constantsModule, cookieService, httpClient, router, modalService, modalInstance);

		// Save button infos.
		this.buttonText = "Réiniatiliser";
		this.enableAction = true;
	}

  ngOnInit(): void {
  }

  public setModalOptions(data:any):void {
		this.userId = data["id"];
		this.userName = data["username"];
	}

  public save(): void {
		this.buttonText = "Veuillez patienter ...";
		this.enableAction = false;

    var newData = {
			"userid": this.userId
		};
		this.put("/api/user-generate-new-password", newData,
      (response:any) => {
        if (response.DATA == "ERR") {
          this.modalInstance.close(response.VALUE);
        } else {
          var modifiedUser = {
          };
          this.modalInstance.dismiss(modifiedUser);
        }
      },
      (err:any) => {
        this.modalInstance.close(err);
      }
    );
  }

}
